import { Box, styled } from '@mui/material';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';

import UsersManagementIcon from '../../../assets/icons/Icon_User_Management.svg?react';
import HomeIcon from '../../../assets/icons/icon-allocate.svg?react';
import ClosePopup from '../../../assets/icons/icon-close-popup.svg?react';
import LogoutIcon from '../../../assets/icons/icon-logout.svg?react';
import SettingsIcon from '../../../assets/icons/icon-settings.svg?react';
import { getKeycloakAdminUrl } from '../../../contexts/OidcContext/Oidc.utils';
import { useOidc } from '../../../contexts/OidcContext/OidcContext';
import { useCurrentUser } from '../../../contexts/OidcContext/OidcContext.selectors';
import { ROUTE_CONFIGURATION, ROUTE_EDITOR, ROUTE_HOME, ROUTE_RESOURCES, ROUTE_SETTINGS } from '../../../routes';

const MenuHeader = styled('div')`
    height: 90px;
    width: 100%;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 33px 26px;
    font-family: Roboto, serif;
    font-size: 28px;
    font-weight: 300;
    line-height: 33px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.blue.darkest};
`;

const MenuContent = styled('div')`
    font-family: Roboto, serif;
    font-size: 20px;
    font-weight: 300;
    letter-spacing: 0;
`;

const MenuItem = styled('div')<{ selected?: boolean }>`
    display: flex;
    align-items: center;
    padding: 10px 25px;
    height: 72px;
    cursor: pointer;
    box-sizing: content-box;
    ${({ selected }) => (selected ? 'background: #ffffff30;' : '')}
`;

const IconContainer = styled('div')`
    margin-right: 15px;
`;

const StyledMenu = styled('div')`
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background: ${({ theme }) => theme.palette.blue.menuBg};
`;

// const HelpIcon = styled(props => <div {...props}>?</div>)<{ size: number }>`
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: ${({ size }) => size}px;
//     height: ${({ size }) => size}px;
//     font-size: ${({ size }) => size * 0.7}px;
//     border-radius: 50%;
//     border: 1px solid white;
// `;

export const Menu = memo(({ closeMenu }: { closeMenu?: () => void }) => {
    const navigate = useNavigate();
    const currentUser = useCurrentUser();
    const logout = useOidc().logout;
    const location = useLocation();
    const isAdmin = currentUser?.admin;
    function handleClickLogout() {
        logout({ redirectTo: 'home' });
    }

    const handleClickUsersManagement = () => {
        if (isAdmin) {
            window.open(getKeycloakAdminUrl(), '_blank');
            closeMenu();
        }
    };

    return (
        <StyledMenu>
            <MenuHeader>
                <Box>
                    {currentUser?.firstName}&nbsp;{currentUser?.lastName}
                </Box>
                <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }}>
                    <ClosePopup onClick={closeMenu} stroke={'#FFFFFF'} />
                </Box>
            </MenuHeader>
            <MenuContent onClick={closeMenu}>
                <MenuItem onClick={() => navigate(ROUTE_HOME)} selected={!!matchPath(ROUTE_HOME, location.pathname)}>
                    <IconContainer>
                        <HomeIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <Box>
                        <FormattedMessage id="menu.rms" />
                    </Box>
                </MenuItem>
                <MenuItem
                    onClick={() => navigate(ROUTE_RESOURCES)}
                    selected={!!matchPath(ROUTE_RESOURCES, location.pathname)}
                >
                    <IconContainer>
                        <HomeIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <Box>
                        <FormattedMessage id="menu.resources" />
                    </Box>
                </MenuItem>
                <MenuItem
                    onClick={() => navigate(ROUTE_EDITOR)}
                    selected={!!matchPath(ROUTE_EDITOR, location.pathname)}
                >
                    <IconContainer>
                        <HomeIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <Box>
                        <FormattedMessage id="menu.editor" />
                    </Box>
                </MenuItem>
                <MenuItem
                    onClick={() => navigate(ROUTE_CONFIGURATION)}
                    selected={!!matchPath(ROUTE_CONFIGURATION, location.pathname)}
                >
                    <IconContainer>
                        <HomeIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <Box>
                        <FormattedMessage id="menu.configuration" />
                    </Box>
                </MenuItem>
                <MenuItem
                    onClick={() => navigate(ROUTE_SETTINGS)}
                    selected={!!matchPath(ROUTE_SETTINGS, location.pathname)}
                >
                    <IconContainer>
                        <SettingsIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <FormattedMessage id="menu.settings" />
                </MenuItem>
                {isAdmin && (
                    <MenuItem onClick={handleClickUsersManagement}>
                        <IconContainer>
                            <UsersManagementIcon width="38" height="38" color="white" />
                        </IconContainer>
                        <FormattedMessage id="menu.usersManagement" />
                    </MenuItem>
                )}
                {/*<MenuItem onClick={() => navigate(ROUTE_HELP)} selected={!!matchPath(ROUTE_HELP, location.pathname)}>*/}
                {/*    <IconContainer>*/}
                {/*        <HelpIcon size={38} />*/}
                {/*    </IconContainer>*/}
                {/*    <FormattedMessage id="menu.help" />*/}
                {/*</MenuItem>*/}
                <MenuItem onClick={handleClickLogout}>
                    <IconContainer>
                        <LogoutIcon width="38" height="38" color="white" />
                    </IconContainer>
                    <FormattedMessage id="menu.logout" />
                </MenuItem>
            </MenuContent>
        </StyledMenu>
    );
});
